import { useCallback } from "react";
import type { ApolloCache } from "@apollo/client";

import {
  createTeamIdentity,
  renameTeamIdentity,
  setTeamIdentityAttributes,
  type CreateTeamIdentityVariables,
} from "./teamIdentityWrites";
import { useOverlayMutate } from "./useOverlayMutate";

type CreateResult = { team?: unknown };

export const useTeamIdentityWrites = () => {
  const write = useOverlayMutate();

  const renameTeam = useCallback(
    (groupId: string, name: string) => renameTeamIdentity(write, groupId, name),
    [write]
  );

  const setAttributes = useCallback(
    (groupId: string, attributes: unknown) =>
      setTeamIdentityAttributes(write, groupId, attributes),
    [write]
  );

  const createTeam = useCallback(
    (
      variables: CreateTeamIdentityVariables,
      update?: (
        cache: ApolloCache,
        result: { data?: CreateResult | null }
      ) => void
    ) => createTeamIdentity(write, variables, update),
    [write]
  );

  return { renameTeam, setAttributes, createTeam };
};
